import React from 'react';
import {Carousel} from '3d-react-carousal';

import {
    Container,
    CarouselContainer,
    Image
} from './styles/certifications';


export default function CertificationSection({children, ...restProps}) {
    return <Container {...restProps}>{children}</Container>
}

CertificationSection.Carousal = function CertificationSectionCarousal({...props}) {
    return <CarouselContainer><Carousel {...props} /></CarouselContainer>
}

CertificationSection.CarousalSlide = function CertificationSectionCarousalSlide ({...props}) {
    return <Image {...props} />
}